<template>
  <div class="slide_main">
    <div class="swiper-container slide1">
      <div class="swiper-wrapper">
        <template v-if="ready">
          <banner-item v-for="item in bannerList" :key="item.bannerId" :banner="item" :width="windowWidth"/>
          <!-- 레이지 로드 API 주소 : https://swiperjs.com/swiper-api#lazy-loading -->
        </template>
      </div>
      <div class="btn_controllLR">
        <div class="swiper-button-prev" />
        <div class="swiper-button-next" />
        <div class="swiper-pagination" />
        <div class="swiper-scrollbar" />
        <button type="button" class="swiper-play" :class="{stop: slideStat}" @click="playSlide()">{{slideBtnTxt}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import BannerItem from './BannerItem.vue';

export default {
  name: 'BannerSection',
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
    windowWidth: {
      type: Number,
      required: true,
    }
  },
  components: {
    BannerItem,
  },
  data: () => ({
    ready: false,
    slideStat: true, /* 병헌 : 상단 비주얼 슬라이드 플레이/정지 변수 */
    slideBtnTxt: 'stop', /* 병헌 : 상단 비주얼 슬라이드 버튼 텍스트 */
  }),
  methods: {
    playSlide(){
      this.$emit('playNstop', !this.slideStat);
      this.slideStat = !this.slideStat;
      if(this.slideStat){
        this.slideBtnTxt = 'stop';
      }else{
        this.slideBtnTxt = 'play';
      }
    }
  },
  watch: {
    bannerList: {
      deep: true,
      handler(v) {
        if (v.length > 0) {
          this.ready = true;
        }
      },
    },
  },
};
</script>

<style>
.swiper-lazy {
  height: 600px;
  background-position: top;
}
</style>
